import { queryOptions, useQuery } from '@tanstack/react-query';

import { makeIsEnabled } from '@cast/utils';

import { apiClient } from '@cast/infrastructure-api';

const WORKLOAD_EVENTS_QUERY_KEY = 'workload-events';

type WorkloadEventsQueryParams = {
  clusterId?: string;
  namespace?: string;
  workloadType?: string;
  workloadName?: string;
  startTime?: string;
  endTime?: string;
  stepSeconds?: number;
  eventTypes?: string[];
  groupByManagedBy?: boolean;
  key: string;
  enabled?: boolean;
};

const getWorkloadEventsQueryOptions = ({
  clusterId,
  namespace,
  workloadType,
  workloadName,
  startTime,
  endTime,
  stepSeconds,
  eventTypes,
  groupByManagedBy,
  key,
  enabled,
}: WorkloadEventsQueryParams) =>
  queryOptions({
    queryKey: [
      WORKLOAD_EVENTS_QUERY_KEY,
      clusterId,
      namespace,
      workloadType,
      workloadName,
      eventTypes,
      key,
    ] as const,
    queryFn: async () => {
      const { data } = await apiClient.costReport.getSingleWorkloadEvents({
        clusterId: clusterId!,
        namespace: namespace!,
        workloadType: workloadType!,
        workloadName: workloadName!,
        startTime: startTime!,
        endTime: endTime!,
        stepSeconds,
        eventTypes,
        groupByManagedBy,
      });
      return data?.series;
    },
    enabled: makeIsEnabled(
      !!clusterId &&
        !!namespace &&
        !!workloadType &&
        !!workloadName &&
        !!startTime &&
        !!endTime,
      enabled
    ),
  });

export const useWorkloadEventsQuery = (params: WorkloadEventsQueryParams) =>
  useQuery(getWorkloadEventsQueryOptions(params));
